import * as UI from "@iyk/ui"
import { Analytics, useAnalytics } from "../../../packages/analytics/analytics.ts"
import { CheckIcon } from "./icons.tsx"

export const ShowScheduleItem = (props: ShowScheduleItem.Props) => {
  const analytics = useAnalytics()
  return (
    <a
      href={props.url}
      onClick={() =>
        analytics.track(
          Analytics.Event.ShowViewed({
            showId: props.id,
            showDate: `${props.month} ${props.dayOfMonth}`,
          }),
        )
      }
      target="_blank"
      rel="noreferrer"
      className="grid grid-cols-[0.25fr_0.75fr] bshadow bshadow-gray-6 cursor-pointer"
    >
      <div className="flex flex-col bshadow-r bshadow-gray-6">
        <div className="flex flex-col justify-between items-start h-full px-3 pt-3 pb-1.5">
          <span className="text-xs-upper">{props.month}</span>
          <span className="text-[28px] tracking-[-0.2px]">{props.dayOfMonth}</span>
        </div>
      </div>
      <div className="flex flex-col gap-1 p-3 relative">
        <div>
          <h3 className="text-sm">{props.venue}</h3>
          <p className="text-sm">
            {props.city}, {props.state}
          </p>
        </div>
        <span className="text-xs text-gray-11">
          {props.dayOfWeek} • {props.time}
        </span>
        {props.checked && <CheckIcon className="size-5 absolute top-2 right-2" />}
        <UI.Icon.ArrowUpRight className="absolute bottom-2 right-2" />
      </div>
    </a>
  )
}

export namespace ShowScheduleItem {
  export type Props = {
    id: string
    url: string
    month: string
    dayOfMonth: string
    dayOfWeek: string
    time: string
    venue: string
    city: string
    state: string
    checked: boolean
  }
}
